'use strict';

if (window !== window.parent) {
  var isErrorPage = function () {
    var navEntries = (performance && performance.getEntriesByType)
      ? performance.getEntriesByType('navigation')
      : [];
    if (navEntries.length > 0 && navEntries[0].responseStatus) {
      var status = navEntries[0].responseStatus;
      if (status === 404 || status === 502) return true;
    }
    return /^(502|404)\b|bad gateway|not found/i.test(document.title);
  };

  if (isErrorPage() || document.body.scrollHeight < 10) {
    window.parent.postMessage('embedHeight:0', '*');
  } else {
    var sendHeight = function () {
      window.parent.postMessage('embedHeight:' + document.body.scrollHeight, '*');
    };
    new ResizeObserver(sendHeight).observe(document.body);
    sendHeight();
  }
}
